import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { processShipment } from 'redux/clubSubscriptionShipments/actions';

const ShipItNow = (props) => {
  const { clubMembership, clubSubscriptionShipment } = props;
  const dispatch = useDispatch();

  const process = (e) => {
    e.preventDefault();
    const successFunction = (newClubMemberShipment) => {
      props.history.push(
        `/profile/order-history/${newClubMemberShipment.orderId}`
      );
    };
    dispatch(processShipment(clubSubscriptionShipment.id, successFunction));
  };
  if (
    clubSubscriptionShipment.status === 'Active' &&
    clubSubscriptionShipment.processingStatus === 'Pending' &&
    clubMembership.customerCreditCard
  ) {
    if (
      clubMembership.shipTo &&
      clubMembership.orderDeliveryMethod === 'Ship'
    ) {
      return (
        <>
          <br />
          <a onClick={process} className="c7-button-small">
            Ship it now
          </a>
          <br />
          <br />
        </>
      );
    }
    return null;
  }

  return null;
};

export default withRouter(ShipItNow);
